var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "top-nav" }, [
        _c("div", { staticClass: "container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("ul", { staticStyle: { float: "right" } }, [
            !_vm.loginStatus
              ? _c(
                  "li",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    !_vm.loginStatus
                      ? _c("img", {
                          staticStyle: { width: "16px", height: "16px" },
                          attrs: { src: "/static/img/login2.png", alt: "" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { on: { click: _vm.login } }, [
                      _vm._v("\n             登录\n          ")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.loginStatus
              ? _c(
                  "li",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "margin-left": "6px"
                    }
                  },
                  [
                    !_vm.loginStatus
                      ? _c("img", {
                          staticStyle: { width: "16px", "margin-left": "6px" },
                          attrs: { src: "/static/img/login3.png", alt: "" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.loginStatus
                      ? _c("span", { on: { click: _vm.upRegister } }, [
                          _vm._v("\n             免费注册\n          ")
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.loginStatus
              ? _c("li", [
                  _c(
                    "a",
                    {
                      staticStyle: {
                        color: "#5D607A",
                        display: "flex",
                        "align-items": "center",
                        "margin-left": "10px"
                      },
                      attrs: {
                        href: "javascript:;",
                        rel: "noopener noreferrer"
                      },
                      on: {
                        click: function($event) {
                          _vm.jumptohome("home")
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "16px" },
                        attrs: { src: "/static/img/home.png", alt: "" }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("\n               云系统首页\n            ")
                      ])
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.loginStatus
              ? _c("li", [
                  _c("span", { staticClass: "user-info" }, [
                    _c("span", { staticClass: "user-name" }, [
                      _vm._v(
                        "欢迎您，" +
                          _vm._s(_vm.account.realname || _vm.account.username) +
                          " |"
                      )
                    ]),
                    _vm._v(" "),
                    _vm.hasCompanyId && _vm.companyList.length > 1
                      ? _c(
                          "span",
                          { staticClass: "change-company" },
                          [
                            _c(
                              "el-dropdown",
                              {
                                staticClass: "el-dropdown",
                                attrs: { placement: "bottom" },
                                on: { command: _vm.changeCompany }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "el-dropdown-link" },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.account.defaultCompany.name
                                        ) +
                                        "\n                  "
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-arrow-down el-icon--right"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    staticClass: "dropdown-menu-company",
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { disabled: "" } },
                                      [_vm._v("您可以切换至以下账户：")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.companyList, function(d, i) {
                                      return _c(
                                        "el-dropdown-item",
                                        { key: i, attrs: { command: d } },
                                        [_vm._v(_vm._s(d.name))]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm.hasCompanyId
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.account.defaultCompany.name))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasCompanyId
                      ? _c(
                          "a",
                          {
                            staticClass: "btn-logout",
                            on: {
                              click: function($event) {
                                _vm.logout()
                              }
                            }
                          },
                          [_vm._v("[退出]")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasCompanyId
                      ? _c(
                          "a",
                          {
                            staticClass: "into-system",
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.loginDefault()
                              }
                            }
                          },
                          [_vm._v("进入系统")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  !_vm.hasCompanyId
                    ? _c("span", { staticStyle: { cursor: "default" } }, [
                        _vm._v("个人账户")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasCompanyId
                    ? _c(
                        "a",
                        {
                          staticStyle: { "margin-right": "4px" },
                          attrs: {
                            href: _vm.$url.accountCenter + "/index.html",
                            target: "_blank"
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "#3C67AD" } }, [
                            _vm._v("| ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                color: "#fff",
                                "background-color": "#3293FA",
                                width: "64px",
                                height: "18px",
                                "line-height": "18px",
                                "text-align": "center",
                                "border-radius": "4px"
                              }
                            },
                            [_vm._v("账户中心")]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("loginbox"),
      _vm._v(" "),
      _c("openupbox")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticStyle: { float: "left", padding: "0" } }, [
      _c("li", { staticClass: "login" }, [
        _c("span", [
          _c(
            "a",
            {
              staticClass: "home-link",
              attrs: {
                href: "https://usoftchina.com/",
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [
              _c("img", {
                staticStyle: { width: "17px", "margin-top": "-3px" },
                attrs: { src: "/static/img/home.png", alt: "" }
              }),
              _vm._v("华商云服\n            ")
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12835cef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12835cef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = null
// module chunks = 